/* eslint-disable camelcase */
import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Container, Divider, Grid, Stack, Typography } from '@mui/material';
import Image from '../../components/Image';
import useLocales from '../../hooks/useLocales';
import { useSelector } from '../../redux/store';
import conObj from '../../utils/connection-assistant';
import palette from '../../theme/palette';

const FooterText = styled(Typography)(({ theme }) => ({
  color: 'white',
  fontWeight: 700,
  fontSize: '.7rem',
}));

const SocialIcons = styled(Image)(({ theme }) => ({
  width: 24,
  height: 24,
  cursor: 'pointer',
}));

const FooterBannerText = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: '1rem',
  textAlign: 'center',
  paddingLeft: '2rem',
  paddingRight: '2rem',
  textShadow: '2px 2px 1px black',
  fontWeight: 500,
  [theme.breakpoints.up('sm')]: {
    fontSize: 18,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '2.5vw',
  },
}));

const FooterIconBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  // alignItems: 'center',
  justifyContent: 'center',
  flexFlow: 'column',
  marginBottom: '2rem',
}));

const CustomDivider = styled(Divider)(({ theme }) => ({
  margin: '1rem 0px',
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
  [theme.breakpoints.down('md')]: {
    display: 'block',
  },
}));

const CustomScrollbar = styled(Stack)({
  overflowY: 'hidden',
  scrollbarWidth: 'thin',
  // scrollbarColor: 'grey #2b2b2b',
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#2b2b2b',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#f48fb1',
    borderRadius: '10px',
    border: '2px solid #2b2b2b',
  },
});

const Footer = () => {
  const { translate } = useLocales();

  const { siteSettings } = useSelector((x) => x.lookup);

  const [activeCompanies, setActiveCompanies] = useState([]);

  const {
    // config_footer_copyright,
    // config_name,
    config_youtube,
    config_whatsapp,
    config_wechat,
    config_viber,
    config_twitter,
    config_telegram,
    config_messenger,
    config_line,
    config_instagram,
    config_facebook,
  } = siteSettings || {};

  const getActiveCompanies = () => {
    conObj.post('/games/active_companies.json').then((res) => {
      if (res.status === 200) {
        setActiveCompanies(res.data?.data?.data);
      }
    });
  };

  const onOpenSocial = (link) => {
    window.open(link, '_blank');
  };

  useEffect(() => {
    getActiveCompanies();
  }, []);

  const displayGameProvidersComponent = (items) => {
    const midIndex = Math.ceil(items.length / 2);
    const firstHalf = items.slice(0, midIndex);
    const secondHalf = items.slice(midIndex);

    return (
      <CustomScrollbar
        direction={'column'}
        spacing={1}
        sx={{
          overflowX: 'scroll',
          mt: 2,
          ml: 0,
          width: '100%',
          padding: '0 20px 20px 10px',
        }}
      >
        <Stack direction={'row'} spacing={1} sx={{ height: '42px' }}>
          {firstHalf.map((item, index) => (
            <Image key={index} src={item?.logo_url} alt="Providers" sx={{ minWidth: '96px', height: '42px' }} />
          ))}
        </Stack>

        <Stack direction={'row'} spacing={1} sx={{ height: '42px' }}>
          {secondHalf.map((item, index) => (
            <Image key={index} src={item?.logo_url} alt="Providers" sx={{ minWidth: '96px', height: '42px' }} />
          ))}
        </Stack>
      </CustomScrollbar>
    );
  };

  return (
    <Box sx={{ overflow: 'hidden', pt: '2rem' }}>
      {/* <Container maxWidth="lg" sx={{ p: '2rem 0 !important' }}>
        <Stack direction="row" alignItems={'center'} spacing={2} sx={{ ml: 2 }}>
          <Typography sx={{ color: '#2D9923', fontSize: '1.2rem', fontStyle: 'italic', fontWeight: 700, mb: 1 }}>
            {translate('our_game_provides')}
          </Typography>
        </Stack>
        {activeCompanies && displayGameProvidersComponent(activeCompanies?.filter((f) => f?.exists === true))}
      </Container> */}

      <Container
        // maxWidth="xl"
        sx={{
          backgroundColor: '#0D5B2D',
          // py: '0px !important',
          // px: '0px !important',
          // pb: '10rem',
          p: '2rem',
          pb: '5rem',
          width: '100%',
          maxWidth: '100% !important',
        }}
      >
        <Stack direction="row" alignItems={'center'} spacing={2} >
          <Typography sx={{ color: '#fff', fontSize: '1.2rem', fontStyle: 'italic', fontWeight: 700, mb: 1 }}>
            {translate('our_game_provides')}
          </Typography>
        </Stack>
        {activeCompanies && displayGameProvidersComponent(activeCompanies?.filter((f) => f?.exists === true))}

        <Box>
          <Typography sx={{ fontSize: '12px', color: '#fff', fontWeight: 400 }}>{translate('follow_us')}</Typography>
          <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
            {!!config_youtube && (
              <Box onClick={() => onOpenSocial(config_youtube)}>
                <SocialIcons src={require('../../assets/social/yt.png')} />
              </Box>
            )}

            {!!config_facebook && (
              <Box onClick={() => onOpenSocial(config_facebook)}>
                <SocialIcons src={require('../../assets/social/fb.png')} />
              </Box>
            )}

            {!!config_instagram && (
              <Box onClick={() => onOpenSocial(config_instagram)}>
                <SocialIcons src={require('../../assets/social/instagram.png')} />
              </Box>
            )}

            {!!config_whatsapp && (
              <Box onClick={() => onOpenSocial(config_whatsapp)}>
                <SocialIcons src={require('../../assets/social/wa.png')} />
              </Box>
            )}

            {!!config_wechat && (
              <Box onClick={() => onOpenSocial(config_wechat)}>
                <SocialIcons src={require('../../assets/social/wechat.png')} />
              </Box>
            )}

            {!!config_viber && (
              <Box onClick={() => onOpenSocial(config_viber)}>
                <SocialIcons src={require('../../assets/social/viber.png')} />
              </Box>
            )}

            {!!config_twitter && (
              <Box onClick={() => onOpenSocial(config_twitter)}>
                <SocialIcons src={require('../../assets/social/twitter.png')} />
              </Box>
            )}

            {!!config_telegram && (
              <Box onClick={() => onOpenSocial(config_telegram)}>
                <SocialIcons src={require('../../assets/social/telegram.png')} />
              </Box>
            )}

            {!!config_messenger && (
              <Box onClick={() => onOpenSocial(config_messenger)}>
                <SocialIcons src={require('../../assets/social/messenger.png')} />
              </Box>
            )}

            {!!config_line && (
              <Box onClick={() => onOpenSocial(config_line)}>
                <SocialIcons src={require('../../assets/social/line.png')} />
              </Box>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
